var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.data,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "move", attrs: { "auto-width": "", props: props } },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "primary",
                          icon: "far fa-arrow-up",
                          disable: !_vm.managePodcasts
                        },
                        on: {
                          click: function($event) {
                            return _vm.moveItem(props, "up")
                          }
                        }
                      }),
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "negative",
                          icon: "far fa-arrow-down",
                          disable: !_vm.managePodcasts
                        },
                        on: {
                          click: function($event) {
                            return _vm.moveItem(props, "down")
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "hierarchy_order", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.hierarchy_order) +
                          "\n                "
                      )
                    ]
                  ),
                  _c("q-td", { key: "audio_title", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.audio_title) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "audio_duration", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.audio_duration) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      key: "audio_status",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.audio_status),
                            color: _vm.getColorStatus(props.row.audio_status)
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t(_vm.getStatus(props.row.audio_status))
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_podcasts" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c(
              "q-btn",
              {
                staticClass: "full-width",
                attrs: {
                  color: "negative",
                  label: _vm.$t("unpublish"),
                  icon: "far fa-ban",
                  disable: _vm.disableButtons || !_vm.managePodcasts
                },
                on: {
                  click: function($event) {
                    return _vm.unpublish()
                  }
                }
              },
              [
                _vm.disableButtons
                  ? _c("q-tooltip", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("no_audios_on_podcast")) +
                          "\n                "
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c(
              "q-btn",
              {
                staticClass: "full-width",
                attrs: {
                  color: "positive",
                  label: _vm.$t("publish"),
                  icon: "far fa-upload",
                  disable: _vm.disableButtons || !_vm.managePodcasts
                },
                on: {
                  click: function($event) {
                    return _vm.publish()
                  }
                }
              },
              [
                _vm.disableButtons
                  ? _c("q-tooltip", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("no_audios_on_podcast")) +
                          "\n                "
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }